import * as React from "react";
import styles from "./summary.module.scss";
import ReactStars from "react-stars";
import { getDistributedRatings, staticRating } from "../../../../utils";

interface IDataProps {
  data: any;
}

const Summary = ({ data }: IDataProps) => {
  const distributedRatings: { [key: string]: number } = getDistributedRatings(
    data?.totalAll
  );

  return (
    <div className={styles.summary}>
      <div className={styles.left}>
        <div className={styles.stars}>
          <h1 className={styles.title}>{staticRating}</h1>
          <ReactStars
            value={staticRating}
            color2="#ffd203"
            color1="#ccc"
            count={5}
            size={30}
            className={styles.starComponent}
            edit={false}
          />
        </div>

        <p className={styles.basedOn}>Based on {data?.totalAll} reviews</p>
      </div>

      <div className={styles.distributedRatings}>
        {Object.keys(distributedRatings)
          .sort((a,b) => {
            if (a < b) {
              return 1
            } else if (a > b) {
              return -1
            }

            return 0
          })
          .map((key: string) => {
            return (
              <div key={key} className={styles.rating}>
                <ReactStars
                  edit={false}
                  value={Number(key)}
                  color2="#999999"
                  color1="#eee"
                  size={18}
                  count={5}
                />
                <div className={styles.bar}>
                  <div
                    className={styles.fill}
                    style={{ width: `${(distributedRatings[key] / data?.totalAll) * 100}%` }}
                  ></div>
                </div>
                <p>({distributedRatings[key]})</p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Summary;
